import { RequestWithRelations } from '@/models/request';
import { ClientArticleStepper } from '@/routes/Brand/Requests/Request/components/shared/ClientArticleStepper';
import useViewPort from '@/utils/useViewport';

import { getArticlesToDisplay } from '../ClientArticlesList';

const ClientStepper = ({ request }: { request: RequestWithRelations }) => {
  const { isMobile } = useViewPort();

  const { articlesToDisplay } = getArticlesToDisplay(request);

  if (articlesToDisplay.length !== 1) {
    return null;
  }

  return (
    <ClientArticleStepper
      size={isMobile ? 'small' : 'large'}
      article={articlesToDisplay[0]}
      showStepCount={isMobile}
    />
  );
};

export default ClientStepper;
